import { useNavigate } from "@/lib/router-compat";
import { useEffect } from "react";
import { DeclinedCard404DE } from "@/components/DeclinedCard404DE";
import { SEOHelmet } from "@/components/SEOHelmet";

const NotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", window.location.pathname);
  }, []);

  return (
    <>
      <SEOHelmet
        title="Seite nicht gefunden – 404"
        description="Die angeforderte Seite wurde nicht gefunden."
        type="website"
        url={typeof window !== 'undefined' ? window.location.href : ''}
        noIndex={true}
      />
      <DeclinedCard404DE 
        onNavigateHome={() => navigate('/')}
      />
    </>
  );
};

export default NotFound;
